import React from 'react';
import AddHeader from '../../../../../components/layout/header/add';
import DataListHandler from '../../../../../components/layout/body/data-list-handler';
import RenderVMContainer from '../../utils/vm-container';
import Button from '../../../../../components/molecules/buttons';
import useModelManagementDetail from './hooks';

function ModelManagementDetail() {
  const {
    vmConfig, navigation, vmModel, removeConfig,
  } = useModelManagementDetail();
  return (
    <div>
      <AddHeader
        primary={{ route: '/vending-machine/model-management', title: 'Model Management' }}
        title={vmModel.data?.model}
      />
      <div className="px-4 px-xl-5">
        <div className="fw-bold fz-14 mb-4">Model Management Detail</div>
        <DataListHandler
          isData={!!vmConfig.list?.data && !!vmConfig.list?.data?.length && vmConfig.list.data.length === vmConfig.list.id.length}
          isLoading={vmModel.load || vmConfig.load}
          isSmall
        >
          <div className="row">
            {vmConfig.list?.data?.map((data, i) => (
              <div className="col-xxl-4 col-lg-6 mb-4 flexible-center flex-column" key={vmConfig.list?.id[i]}>
                <RenderVMContainer data={data} />
                <Button.Default
                  id="submit"
                  type="button"
                  label="REMOVE"
                  size="lg"
                  onClick={() => removeConfig.handler(vmConfig.list?.id[i])}
                  loading={removeConfig.load}
                  style={{ width: 380 }}
                />
              </div>
            ))}
          </div>
        </DataListHandler>
      </div>
      <div className="w-100 bg-stroke my-4" style={{ height: '7px' }} />
      <div className="d-flex justify-content-end p-4 px-xl-5">
        <div style={{ width: '200px', marginRight: '20px' }}>
          <Button.Default
            id="cancel"
            type="button"
            label="Cancel"
            size="lg"
            outline
            onClick={navigation.back}
          />
        </div>
        <div style={{ width: '200px' }}>
          <Button.Default
            id="submit"
            type="button"
            label="Add Configuration"
            size="lg"
            onClick={navigation.add}
          />
        </div>
      </div>
    </div>
  );
}

export default ModelManagementDetail;
